module.exports = __webpack_public_path__ + "img/GDQ-matcirkel_20.342ca4bb.gif";